export enum MeasurementActionTypes {
    LOAD_MEASUREMENT_REF = "LOAD_MEASUREMENT_REF",
    SET_ACTIVE_MEASUREMENT_TYPE = "SET_ACTIVE_MEASUREMENT_TYPE",
    RESET_MEASUREMENT = "RESET_MEASUREMENT",

    MEASUREMENT_LOAD_MEASUREMENT_REF = "measurement/LOAD_MEASUREMENT_REF",
    MEASUREMENT_SET_ACTIVE_MEASUREMENT_TYPE = "measurement/SET_ACTIVE_MEASUREMENT_TYPE",
    MEASUREMENT_RESET_MEASUREMENT = "measurement/RESET_MEASUREMENT",
}